import React from 'react';

export default function DannebroginvestFrontPage() {
    return <img style={{ marginLeft: 'auto', marginRight: 'auto', width: '500px', height: 'auto' }} src="/assets/img/dannebroginvest/dannebroginvest-logo.png" />;
}
